import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Autocomplete,
  CircularProgress,
  Divider
} from "@mui/material";
import axios from "axios";
import { PURCHASE_API_ENDPOINTS } from "../../../config/api/apiCallPurchase";
import Header from "../../../Layout/Header";
import { Email } from "@mui/icons-material";
import { pdf } from '@react-pdf/renderer';
import MultiVendorEnquiryPDF from "./MultiVendorEnquiryPDF";
const VendorEnquiryMail = ({ enquiry, handlecallbacktoVendorEnquiry, enquiryNo,enquiryReportData }) => {
  const [subject, setSubject] = useState('Request for Quotation (RFQ) – Material Enquiry');
  const [message, setMessage] = useState("");
  // const [vendors, setVendors] = useState([]);
  const [vendors, setVendors] = useState([]);        // multiple selected vendors
const [activeVendor, setActiveVendor] = useState(null); // one vendor at a time


  const [loading, setLoading] = useState(false);
  const [fromEmail, setFromEmail] = useState(enquiry.vendors[0].employee_email || "");
const getMaterialSet = (vendor) =>
  new Set((vendor.materials || []).map(m => m.code));

const hasSameMaterials = (baseVendor, compareVendor) => {
  const baseSet = getMaterialSet(baseVendor);
  const compareSet = getMaterialSet(compareVendor);

  if (baseSet.size !== compareSet.size) return false;

  for (let m of baseSet) {
    if (!compareSet.has(m)) return false;
  }
  return true;
};


const generateVendorPdfs = async () => {
  const files = [];

  const seenVendors = new Set();

  for (const vendor of enquiryReportData) {
    const key = vendor.receivercompanyname?.trim().toLowerCase();
    if (seenVendors.has(key)) continue;

    const doc = <MultiVendorEnquiryPDF vendors={[vendor]} />;
    const blob = await pdf(doc).toBlob();

    files.push({
      vendorEmail: vendor.email,
      file: new File(
        [blob],
        `Vendor_Enquiry_${vendor.receivercompanyname.replace(/\s+/g, '_')}.pdf`,
        { type: "application/pdf" }
      )
    });

    seenVendors.add(key);
  }

  return files;
};


  const textToHtml = (text) => {
    return text
      .replace(/\n\n/g, "</p><p>")
      .replace(/\n/g, "<br/>")
      .replace(/^/, "<p>")
      .concat("</p>");
  };

//   useEffect(() => {
//     if (!enquiry?.vendors[0].materials?.length) return;

//     const intro = `Dear Sir/Madam,

// We kindly request you to share your best quotation for the following materials. Please include delivery time, payment terms, and any applicable taxes or charges.
// `;

//     const title = `\nRequired Materials :\n`;

//     const materialsText = enquiry?.vendors[0].materials
//       .map(m =>
//         `- ${m.code} | ${m.description} | ${m.requested} ${m.uom}${m.remarks ? ` | Remarks: ${m.remarks}` : ""
//         }`
//       )
//       .join("\n");

//     setMessage(intro + title + materialsText);
//   }, [enquiry.vendors[0].materials]);

const getNameFromEmail = (email) => {
  if (!email || !email.includes("@")) return "[Your Name]";
  return email.split("@")[0]
    .replace(/[._]/g, " ")
    .replace(/\b\w/g, char => char.toUpperCase());
};


// useEffect(() => {
//   if (!enquiry?.vendors?.[0]?.materials?.length) return;

//   const intro = `Dear Sir/Madam,

// We request you to share your best quotation for the following materials as per the details below.
// `;

//   const headerTerms = `
// Commercial Terms :

// Freight            : Paid / To Pay (please specify)
// Expected Delivery Date  : DD/MMM/YYYY
// Payment Terms      : _____ days
// Discount           : _____ %
// TDS                : Applicable / Not Applicable
// (If applicable, please mention TDS % and details)
// `;

//   const materialHeader = `
// Material Details :

// Material Code | Description | Quantity | CGST % | SGST % | IGST %
// `;

//   const materialsText = enquiry.vendors[0].materials
//     .map(m =>
//       `${m.code} | ${m.description} | ${m.requested} ${m.uom} | ___ % | ___ % | ___ %`
//     )
//     .join("\n");

//   const notes = `
// Notes:
// - Prices should be exclusive of GST unless stated otherwise
// - Kindly mention validity of the quotation
// - Any additional charges (if applicable) should be clearly specified

// Thanks & Regards,
// ${getNameFromEmail(fromEmail)}
// `;


//   setMessage(
//     intro +
//     "\n" +
//     headerTerms +
//     "\n" +
//     materialHeader +
//     materialsText +
//     "\n" +
//     notes
//   );
// }, [enquiry, fromEmail]);


useEffect(() => {
  if (!vendors || vendors.length === 0) return;

  const intro = `Dear Sir/Madam,

We request you to share your best quotation for the following materials as per the details below.Kindly send your quote within 7days.
`;

  const headerTerms = `
Commercial Terms :

Freight                 : Paid / To Pay (please specify)
Expected Delivery Date  : DD/MMM/YYYY
Payment Terms           : _____ days
Discount                : _____ %
TDS                     : Applicable / Not Applicable
(If applicable, please mention TDS % and details)
`;

const materialHeader = `
Material Details :

Material Code | Description | Req Qty | Offered Qty | UOM | Unit Price | CGST % | SGST % | IGST %
`;


  // 🔥 build material list ONLY from selected vendors
 

const materialsText = (() => {
  if (!vendors || vendors.length === 0) return "";

  const materialMap = new Map();

  vendors.forEach(vendor => {
    (vendor.materials || []).forEach(m => {
      if (!materialMap.has(m.code)) {
        materialMap.set(m.code, m);
      }
    });
  });

  return Array.from(materialMap.values())
    .map(m =>
      `${m.code} | ${m.description} | ${m.requested} | ___ | ${m.uom} | ___ | ___ % | ___ % | ___ %`
    )
    .join("\n");
})();



  if (!materialsText) return;

  const notes = `
Notes:
- Prices should be exclusive of GST unless stated otherwise
- Kindly mention validity of the quotation
- Any additional charges (if applicable) should be clearly specified

Thanks & Regards,
${getNameFromEmail(fromEmail)}
`;

  setMessage(
    intro 
  );
}, [vendors, fromEmail]);




  const handleSend = async () => {
    if (!vendors.length) {
      alert("Select at least one vendor");
      return;
    }
    if (!fromEmail || !fromEmail.includes("@")) {
      alert("Enter a valid From Email");
      return;
    }


    setLoading(true);

    const pdfFiles = await generateVendorPdfs();
  const formData = new FormData();

  formData.append("enquiryNo", enquiryNo);
  formData.append("subject", subject);
  //formData.append("message", textToHtml(message));
    formData.append("message", message);
  formData.append("fromEmail", fromEmail);

  vendors.forEach(v => formData.append("vendors", v.email));

  pdfFiles.forEach(p => {
    formData.append("files", p.file);
    formData.append("fileVendorMap", p.vendorEmail);
  });

    // const payload = {
    //   enquiryNo: enquiryNo,
    //   subject,
    //   message: textToHtml(message), // 👈 convert here
    //   message_pdf: message,
    //   fromEmail,
    //   vendors: vendors.map(v => v.email)
    // };

    try {
     await axios.post(
  PURCHASE_API_ENDPOINTS.VendorEnquiryMailSend,
  formData
);

      alert("Mail sent successfully 🚀");
      setLoading(false);
    } catch (err) {
      console.error(err);
      alert("Mail sending failed ❌");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>


      <Header title={'Send Vendor Enquiry'} callback={handlecallbacktoVendorEnquiry} />

      <Divider />

      <Box p={2}>



        <Typography
          variant="body1"
          sx={{ fontWeight: 'normal', fontSize: '16px', mb: 2 }}
        >
          Enquiry No: {enquiryNo}
        </Typography>

          <TextField
          fullWidth
          label="From Email (Reply-To)"
          value={fromEmail}
          onChange={(e) => setFromEmail(e.target.value)}
          margin="normal"
          size="small"
          color="secondary"
          placeholder="yourname@company.com"
        />


        {/* Vendors */}
<Autocomplete
  multiple
  options={enquiry.vendors}
  value={vendors}
  getOptionLabel={(option) => option.name}
  onChange={(e, selected) => {
    if (selected.length === 0) {
      setVendors([]);
      return;
    }

    // First vendor decides the material group
    const baseVendor = selected[0];
    const baseMaterials = new Set(
      (baseVendor.materials || []).map(m => m.code)
    );

    const validVendors = selected.filter(vendor => {
      const vendorMaterials = new Set(
        (vendor.materials || []).map(m => m.code)
      );

      if (vendorMaterials.size !== baseMaterials.size) return false;

      for (let m of baseMaterials) {
        if (!vendorMaterials.has(m)) return false;
      }
      return true;
    });

    if (validVendors.length !== selected.length) {
      alert('You can only select vendors with the same material list')
    }

    setVendors(validVendors);
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      color="secondary"
      label="Vendors (BCC)"
      size="small"
      placeholder="Select Vendors"
      margin="normal"
    />
  )}
/>


      


        {/* Subject */}
        <TextField
          fullWidth
          label="Subject"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          margin="normal"
          size="small"
          color="secondary"
        />

        {/* Message */}
        <TextField
          fullWidth
          label="Message"
          color="secondary"
          multiline
          rows={12}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          margin="normal"
          size="small"
        />

        {/* PDF Info */}
        <Typography variant="body2" mt={1} color="gray">
          📎 Enquiry PDF will be attached automatically
        </Typography>

        {/* Send Button */}
        <Box mt={3}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleSend}
            disabled={loading}
            startIcon={!loading && <Email  />}
            sx={{ fontSize: "14px", padding: "4px 18px" }}
          >
            {loading ? <CircularProgress size={20} color="inherit" /> : "Send Mail"}
          </Button>

        </Box>
      </Box>
    </Box>
  );
};

export default VendorEnquiryMail;
